<script lang="ts" setup>
import { computed } from 'vue'

import icons, { type IconNames, type IconsType } from '@/components/Icons/index'

const props = defineProps<{
  name: IconNames
}>()

const iconComponent = computed(() => {
  const componentName: IconsType =
    `Icon${props.name.replace(/-(.)/g, (_, c) => c.toUpperCase()).ucfirst()}` as IconsType
  return icons[componentName] || null
})
</script>

<template>
  <component :is="iconComponent" />
</template>
